import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Booklet, StrapiFile } from '@common/core/models';
import { COST_SUMMARY_CONFIG } from '@web/core/utils/document-pdf-generator.util';

@Component({
  selector: 'casa-doc-booklet-cost-summaries',
  template: `
    <ng-container *ngIf="files.length">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <div class="mat-title-medium">{{ 'BOOKLETS_DETAILS.COST_SUMMARY' | translate }}</div>
        <casa-doc-text-to-speech-button [message]="'TEXT_TO_SPEECH.COST_SUMMARY' | translate" />
      </div>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ 'BOOKLETS_DETAILS.COST_SUMMARY' | translate }} ({{ files.length }})
          </mat-panel-title>
        </mat-expansion-panel-header>

        <mat-list>
          <mat-list-item *ngFor="let file of files; trackBy: trackByFileId" class="p-0">
            <div class="row m-0 w-100">
              <div class="col-2 pl-0 pr-0">
                <mat-icon>picture_as_pdf</mat-icon>
              </div>
              <div class="col-17 mat-body-small text-truncate">
                {{ file.name }} <br />
                ({{ file.size | bitfBytes }})
              </div>
              <div class="col-5 pl-0 pr-0">
                <div class="w-100 h-100 d-flex align-items-start justify-content-end">
                  <button
                    mat-icon-button
                    type="button"
                    [attr.aria-label]="'BOOKLETS_DETAILS.DOWNLOAD' | translate"
                    (click)="onDownloadFile(file)"
                  >
                    <mat-icon>download</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </mat-list-item>
        </mat-list>
      </mat-expansion-panel>
    </ng-container>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BookletCostSummariesComponent {
  @Input() booklet: Booklet;

  // All the generated summaries (separated or unified) are shown together in a single panel
  get files(): StrapiFile[] {
    return getBookletCostSummaryFiles(this.booklet);
  }

  trackByFileId(_index: number, file: StrapiFile): number {
    return file.id;
  }

  onDownloadFile(file: StrapiFile): void {
    window.open(file.url, '_blank');
  }
}

function getBookletCostSummaryFiles(booklet: Booklet | undefined): StrapiFile[] {
  return Object.values(COST_SUMMARY_CONFIG)
    .map(({ attachmentName }) => booklet?.bookletAttachments?.[attachmentName])
    .filter((attachment) => attachment?.visible !== false)
    .flatMap((attachment) => attachment?.file ?? []);
}

export function hasBookletCostSummaries(booklet: Booklet | undefined): boolean {
  return getBookletCostSummaryFiles(booklet).length > 0;
}
